import './Header.css'
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header>
      <nav className='container'>
        <div className="logo-container">
          <Link to="/">
            <img src='/images/gallery/LOGO.jpg' alt="Tours Bouillon Logo" />
          </Link>
        </div>

        <button className="menu-toggle" onClick={toggleMenu}>
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>

        <div className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
          <ul>
            <div className='menu-link-left'>
              <li><Link to="/" onClick={toggleMenu}>ACCUEIL</Link></li>
              <li><Link to="/menu" onClick={toggleMenu}>MENU</Link></li>
              <li><Link to="/reservation" onClick={toggleMenu}>RESERVATION</Link></li>
            </div>
            <div className='menu-link-right'>
              <li><Link to="/about" onClick={toggleMenu}>À PROPOS</Link></li>
              <li><Link to="/contact" onClick={toggleMenu}>CONTACT</Link></li>
              <li><Link to="/gallerie" onClick={toggleMenu}>GALERIE</Link></li>
            </div>
          </ul>
        </div>
      </nav>
    </header>
  );
}

export default Header;
